import api from './api';

class ContractService {
  static async getContracts(params = {}) {
    try {
      //console.log('=== ContractService.getContracts START ===');
      //console.log('ContractService.getContracts called with params:', params);
      //console.log('API base URL:', api.defaults.baseURL);
      //console.log('API headers:', api.defaults.headers);
      //console.log('Making API call to /contracts');

      const response = await api.get('/contracts', { params });

      //console.log('API response received:', response);
      //console.log('Response status:', response.status);
      //console.log('Response headers:', response.headers);
      //console.log('Response data:', response.data);
      //console.log('Response data type:', typeof response.data);
      //console.log('Response data keys:', Object.keys(response.data || {}));

      //console.log('=== ContractService.getContracts END ===');
      return response.data;
    } catch (error) {
      console.error('=== ContractService.getContracts ERROR ===');
      console.error('Error fetching contracts:', error);
      console.error('Error type:', typeof error);
      console.error('Error name:', error.name);
      console.error('Error message:', error.message);
      console.error('Error stack:', error.stack);
      console.error('Error response:', error.response);
      console.error('Error response status:', error.response?.status);
      console.error('Error response data:', error.response?.data);
      console.error('Error config:', error.config);
      console.error('=== ContractService.getContracts ERROR END ===');
      throw error;
    }
  }

  static async getUserContracts(params = {}) {
    try {
      const response = await api.get('/contracts/user', { params });
      return response.data;
    } catch (error) {
      console.error('=== ContractService.getUserContracts ERROR ===');
      console.error('Error fetching user contracts:', error);
      throw error;
    }
  }

  static async getContractById(contractId) {
    try {
      //console.log('=== ContractService.getContractById START ===');
      //console.log('ContractService.getContractById called with contractId:', contractId);

      const response = await api.get(`/contracts/${contractId}`);

      //console.log('API response received:', response);
      //console.log('Response data:', response.data);
      //console.log('=== ContractService.getContractById END ===');
      return response.data;
    } catch (error) {
      console.error('=== ContractService.getContractById ERROR ===');
      console.error('Error fetching contract:', error);
      console.error('Error response:', error.response);
      console.error('=== ContractService.getContractById ERROR END ===');
      throw error;
    }
  }

  static async deleteContract(contractId) {
    try {
      //console.log('=== ContractService.deleteContract START ===');
      //console.log('ContractService.deleteContract called with contractId:', contractId);

      const response = await api.delete(`/contracts/${contractId}`);

      //console.log('API response received:', response);
      //console.log('Response data:', response.data);
      //console.log('=== ContractService.deleteContract END ===');
      return response.data;
    } catch (error) {
      console.error('=== ContractService.deleteContract ERROR ===');
      console.error('Error deleting contract:', error);
      console.error('Error response:', error.response);
      console.error('=== ContractService.deleteContract ERROR END ===');
      throw error;
    }
  }

  static async getContractTypes() {
    try {
      //console.log('=== ContractService.getContractTypes START ===');

      const response = await api.get('/contracts/types/available');

      //console.log('API response received:', response);
      //console.log('Response data:', response.data);
      //console.log('=== ContractService.getContractTypes END ===');
      return response.data;
    } catch (error) {
      console.error('=== ContractService.getContractTypes ERROR ===');
      console.error('Error fetching contract types:', error);
      console.error('Error response:', error.response);
      console.error('=== ContractService.getContractTypes ERROR END ===');
      throw error;
    }
  }

  static async getContractStatuses() {
    try {
      //console.log('=== ContractService.getContractStatuses START ===');

      const response = await api.get('/contracts/statuses/available');

      //console.log('API response received:', response);
      //console.log('Response data:', response.data);
      //console.log('=== ContractService.getContractStatuses END ===');
      return response.data;
    } catch (error) {
      console.error('=== ContractService.getContractStatuses ERROR ===');
      console.error('Error fetching contract statuses:', error);
      console.error('Error response:', error.response);
      console.error('=== ContractService.getContractStatuses ERROR END ===');
      throw error;
    }
  }

  static async approveContract(contractId, comments = '') {
    try {
      //console.log('=== ContractService.approveContract START ===');
      //console.log('ContractService.approveContract called with contractId:', contractId);
      //console.log('Comments:', comments);

      const response = await api.post(`/contracts/${contractId}/approve`, { comments });

      //console.log('API response received:', response);
      //console.log('Response data:', response.data);
      //console.log('=== ContractService.approveContract END ===');
      return response.data;
    } catch (error) {
      console.error('=== ContractService.approveContract ERROR ===');
      console.error('Error approving contract:', error);
      console.error('Error response:', error.response);
      console.error('=== ContractService.approveContract ERROR END ===');
      throw error;
    }
  }

  static async rejectContract(contractId, reason) {
    try {
      //console.log('=== ContractService.rejectContract START ===');
      //console.log('ContractService.rejectContract called with contractId:', contractId);
      //console.log('Reason:', reason);

      const response = await api.post(`/contracts/${contractId}/reject`, { reason });

      //console.log('API response received:', response);
      //console.log('Response data:', response.data);
      //console.log('=== ContractService.rejectContract END ===');
      return response.data;
    } catch (error) {
      console.error('=== ContractService.rejectContract ERROR ===');
      console.error('Error rejecting contract:', error);
      console.error('Error response:', error.response);
      console.error('=== ContractService.rejectContract ERROR END ===');
      throw error;
    }
  }

  static async createContract(contractData) {
    try {
      //console.log('=== ContractService.createContract START ===');
      //console.log('ContractService.createContract called with data:', contractData);
      if (process.env.NODE_ENV !== 'production') {
        console.debug('ContractService.createContract payload:', contractData);
      }

      const response = await api.post('/contracts', contractData);

      if (process.env.NODE_ENV !== 'production') {
        console.debug('ContractService.createContract response:', response.data);
      }

      //console.log('API response received:', response);
      //console.log('Response data:', response.data);
      //console.log('=== ContractService.createContract END ===');
      return response.data;
    } catch (error) {
      console.error('Error creating contract:', error);
      console.error('Error response:', error.response?.data);
      throw error;
    }
  }

  static async updateContract(contractId, contractData) {
    try {
      //console.log('=== ContractService.updateContract START ===');
      //console.log('ContractService.updateContract called with ID:', contractId);
      //console.log('ContractService.updateContract called with data:', contractData);

      const response = await api.put(`/contracts/${contractId}`, contractData);

      //console.log('API response received:', response);
      //console.log('Response data:', response.data);
      //console.log('=== ContractService.updateContract END ===');
      return response.data;
    } catch (error) {
      console.error('=== ContractService.updateContract ERROR ===');
      console.error('Error updating contract:', error);
      console.error('Error response:', error.response?.data);
      console.error('=== ContractService.updateContract ERROR END ===');
      throw error;
    }
  }

  static async getRenewalAlerts(params = {}) {
    try {
      const response = await api.get('/contracts/renewals', { params });
      return response.data;
    } catch (error) {
      console.error('ContractService.getRenewalAlerts ERROR', error);
      throw error;
    }
  }

  static async renewContract(contractId, payload = {}) {
    try {
      const response = await api.post(`/contracts/${contractId}/renew`, payload);
      return response.data;
    } catch (error) {
      console.error('ContractService.renewContract ERROR', error);
      throw error;
    }
  }

  static async getTerminatedContracts(params = {}) {
    try {
      const response = await api.get('/contracts/terminations', { params });
      return response.data;
    } catch (error) {
      console.error('ContractService.getTerminatedContracts ERROR', error);
      throw error;
    }
  }

  static async getContractAnalytics() {
    try {
      const response = await api.get('/contracts/analytics');
      return response.data;
    } catch (error) {
      console.error('ContractService.getContractAnalytics ERROR', error);
      throw error;
    }
  }

  static async getContractCompliance(contractId, params = {}) {
    try {
      const response = await api.get(`/contracts/${contractId}/compliance`, { params });
      return response.data;
    } catch (error) {
      console.error('ContractService.getContractCompliance ERROR', error);
      throw error;
    }
  }

  static async getVendorScreening(contractId) {
    try {
      const response = await api.get(`/contracts/${contractId}/vendor-screening`);
      return response.data;
    } catch (error) {
      console.error('ContractService.getVendorScreening ERROR', error);
      throw error;
    }
  }

  static async upsertVendorScreening(contractId, payload) {
    try {
      const response = await api.post(`/contracts/${contractId}/vendor-screening`, payload);
      return response.data;
    } catch (error) {
      console.error('ContractService.upsertVendorScreening ERROR', error);
      throw error;
    }
  }

  static async getContractComplianceById(contractId, complianceId) {
    try {
      const response = await api.get(`/contracts/${contractId}/compliance/${complianceId}`);
      return response.data;
    } catch (error) {
      console.error('ContractService.getContractComplianceById ERROR', error);
      throw error;
    }
  }

  static async createContractCompliance(contractId, payload) {
    try {
      const response = await api.post(`/contracts/${contractId}/compliance`, payload);
      return response.data;
    } catch (error) {
      console.error('ContractService.createContractCompliance ERROR', error);
      throw error;
    }
  }

  static async updateContractCompliance(contractId, complianceId, payload) {
    try {
      const response = await api.put(`/contracts/${contractId}/compliance/${complianceId}`, payload);
      return response.data;
    } catch (error) {
      console.error('ContractService.updateContractCompliance ERROR', error);
      throw error;
    }
  }

  static async deleteContractCompliance(contractId, complianceId) {
    try {
      const response = await api.delete(`/contracts/${contractId}/compliance/${complianceId}`);
      return response.data;
    } catch (error) {
      console.error('ContractService.deleteContractCompliance ERROR', error);
      throw error;
    }
  }

  static async uploadComplianceEvidence(contractId, complianceId, formData) {
    try {
      // OLD (Caused Error): 
      // const response = await api.post(`/contracts/${contractId}/compliance/${complianceId}/evidence`, ...

      // NEW (Correct): Point to the 'compliance' route
      const response = await api.post(
        `/contracts/${contractId}/compliance/${complianceId}/evidence`, 
        formData, 
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('ContractService.uploadComplianceEvidence ERROR', error);
      throw error;
    }
  }

  static async getAllObligations(filters = {}) {
    try {
      // Converts object { status: 'active', risk: 'high' } into string "status=active&risk=high"
      const queryParams = new URLSearchParams(filters).toString();
      const response = await api.get(`/contracts/obligations?${queryParams}`);
      return response.data;
    } catch (error) {
      console.error('ContractService.getAllObligations ERROR', error);
      throw error;
    }
  }

  static async getFixedPrice(contractId) {
    try {
      const response = await api.get(`/contracts/${contractId}/fixed-price`);
      return response.data;
    } catch (error) {
      console.error('ContractService.getFixedPrice ERROR', error);
      throw error;
    }
  }

  static async getFixedPriceById(contractId, fixedPriceId) {
    try {
      const response = await api.get(`/contracts/${contractId}/fixed-price/${fixedPriceId}`);
      return response.data;
    } catch (error) {
      console.error('ContractService.getFixedPriceById ERROR', error);
      throw error;
    }
  }

  static async createFixedPrice(contractId, payload) {
    try {
      const response = await api.post(`/contracts/${contractId}/fixed-price`, payload);
      return response.data;
    } catch (error) {
      console.error('ContractService.createFixedPrice ERROR', error);
      throw error;
    }
  }

  static async updateFixedPrice(contractId, fixedPriceId, payload) {
    try {
      const response = await api.put(`/contracts/${contractId}/fixed-price/${fixedPriceId}`, payload);
      return response.data;
    } catch (error) {
      console.error('ContractService.updateFixedPrice ERROR', error);
      throw error;
    }
  }

  static async deleteFixedPrice(contractId, fixedPriceId) {
    try {
      const response = await api.delete(
        `/contracts/${contractId}/fixed-price/${fixedPriceId}`
      );
      return response.data;
    } catch (error) {
      console.error('ContractService.deleteFixedPrice ERROR', error);
      throw error;
    }
  }

  static async applyLegalHold(contractId, reason) {
    try {
      const response = await api.post(
        `/contracts/${contractId}/legal-hold/apply`,
        { reason }
      );
      return response.data;
    } catch (error) {
      console.error('ContractService.applyLegalHold ERROR', error);
      throw error;
    }
  }

  static async releaseLegalHold(contractId, reason) {
    try {
      const response = await api.post(
        `/contracts/${contractId}/legal-hold/remove`,
        { reason }
      );
      return response.data;
    } catch (error) {
      console.error('ContractService.releaseLegalHold ERROR', error);
      throw error;
    }
  }
}

export default ContractService;
